/* eslint-disable no-lonely-if */
import React, { Component } from 'react';
// import { withRouter } from 'react-router-dom';
import StarRatingComponent from 'react-star-rating-component';
import loadImage from 'blueimp-load-image';
import Popup from 'reactjs-popup';
import {
  Link,
  withRouter,
} from 'react-router-dom';
import { initMixpanel } from '../utils/mixpanelConsent';

import './Product.css';
import AuthService from './AuthService';
import Loading from './assets/loading.gif';
import constants from '../config';
import AuthModalContext from '../contexts/AuthModalContext';

const Auth = new AuthService();
initMixpanel();

class Product extends Component {
  static contextType = AuthModalContext;
  constructor(props) {
    super();
    this.state = {
      isFavorited: false,
      favoriteCount: props.favoriteCount,
      shareIcon: false,
      shareCount: props.shareCount,
      viewLink: `/product/${String(props._id)}`,
      displaySold: 'none',
      sharesLink: `/shares/${String(props._id)}`,
      favoritesLink: `/favorites/${String(props._id)}`,
    };
    this.toProfile = this.toProfile.bind(this);
    this.iconState = this.iconState.bind(this);
    this.favorite = this.favorite.bind(this);
    this.share = this.share.bind(this);
    this.delete = this.delete.bind(this);
    this.report = this.report.bind(this);
    this.shareByTweet = this.shareByTweet.bind(this);
    this.shareViaFacebook = this.shareViaFacebook.bind(this);
    this.shareViaPinterest = this.shareViaPinterest.bind(this);
    this.copyLink = this.copyLink.bind(this);
  }
  componentDidMount() {
    // did we share or like this?
    const api = `${constants.DOMAIN}/`;
    // const url = api + this.props.image;
    //   console.log(this.props.title, url);
    this.iconState();
    if (this.props.marketer) { // this works in detection of a marketer
      this.setState({
        // editPost: <Link to={`/edit/${this.props.post_id}`} className="btn options-item">Edit post <i style={{ color: '#ffd788'}} className="fa fa-pencil-square" aria-hidden="true"></i></Link>,
        viewLink: `/share/${String(this.props._id)}`,
        sharesLink: `/shares/${String(this.props.post_id)}`,
        favoritesLink: `/favorites/${String(this.props.post_id)}`,
        marketer: <p className="didMarket" style={{ color: '#00000075' }} ><i className="fa fa-retweet" style={{ color: '#00000075' }} aria-hidden="true" /> {this.props.marketer.name}</p>,
      });
    }
    const cat = (this.props.category || '').split(' ');
    if (cat[1] === 'social') {
      // this is a social post
      let imageContainer;
      if (this.props.image === undefined) {
        imageContainer = document.getElementById(`productCompContainer.${this.props._id}`);
        imageContainer.innerHTML = '';
      } else {
        const url = api + this.props.image;
        imageContainer = document.getElementById(`productCompContainer.${this.props._id}`);
        loadImage(
          url,
          (img) => {
            if (img.type === 'error') {
              // console.log(`Error loading image ${  url}`);
            } else {
              img.id = 'productImage';
              img.setAttribute('style', 'width: 100%;');
              imageContainer.innerHTML = '';
              imageContainer.appendChild(img);
              const heading = document.createElement('h3');
      const title = document.createTextNode(this.props.title);
      heading.appendChild(title);
      heading.setAttribute('style', 'padding-left: 5%;');
      imageContainer.appendChild(heading);
            }
          },
          { maxWidth: 600, orientation: true, canvas: false }
        );
      }
      
      const heading = document.createElement('h3');
      const title = document.createTextNode(this.props.title);
      heading.appendChild(title);
      heading.setAttribute('style', 'padding-left: 5%;');
      imageContainer.appendChild(heading);

      const sold = <Link to={this.state.viewLink}  className="btn soldButton"><strong>{cat[0].toUpperCase()}</strong></Link>;
      this.setState({ productStatus: sold });
    } else {
      // this is a product
      if (this.props.sold) {
        // if this was sold show the sold button
        // eslint-disable-next-line 
        const sold = <a className="btn soldButton"><strong>Sold</strong></a>;
        this.setState({ productStatus: sold });
      } else {
        let buy;

        if (this.props.marketer) {
          // if this was shared then show the affiliate link
          buy = <Link to={`/share/${String(this.props._id)}`} className="btn buyButton"><strong> ${(this.props.price || 0).toFixed(2)}</strong><i style={{ float: 'right', marginRight: '20px' }} className="fa fa-angle-right fa-3x" aria-hidden="true" /></Link>;
          this.setState({ productStatus: buy });
        } else {
          // regular link
          buy = <Link to={`/product/${String(this.props._id)}`} className="btn buyButton"><strong> ${(this.props.price || 0).toFixed(2)}</strong><i style={{ float: 'right', marginRight: '20px' }} className="fa fa-angle-right fa-3x" aria-hidden="true" /></Link>;
          this.setState({ productStatus: buy });
        }
      }
      const url = api + this.props.image;
      const imageContainer = document.getElementById(`productCompContainer.${this.props._id}`);
      loadImage(
        url,
        (img) => {
          if (img.type === 'error') {
            // console.log(`Error loading image ${  url}`);
          } else {
            img.id = 'productImage';
            img.setAttribute('style', 'width: 100%;');
            imageContainer.innerHTML = '';
            imageContainer.appendChild(img);
          }
        },
        { maxWidth: 600, orientation: true, canvas: false }
      );
    }
    if (Auth.getToken()) { // is user
      const user = Auth.getProfile();
      if (user._id === this.props.sellerId && this.props.sold === false) {
        this.setState({
          // eslint-disable-next-line 
          reportDeleteIcon: <a onClick={this.delete} className="btn options-item">Delete <i style={{ color: '#c9a84c' }} className="fa fa-times" aria-hidden="true" /></a>,
          editPost: <div id="editOption" className="menu-item"><Link to={`/edit/${this.props.post_id}`} className="btn options-item">Edit post <i style={{ color: '#ffd788' }} className="fa fa-pencil-square" aria-hidden="true" /></Link></div>,
        });
      }
      if (user._id === this.props.sellerId && this.props.sold === false && !this.props.marketer) {
        this.setState({ editPost: <div id="editOption" className="menu-item"><Link to={`/edit/${this.props._id}`} className="btn options-item">Edit post <i style={{ color: '#ffd788' }} className="fa fa-pencil-square" aria-hidden="true" /></Link></div> });
      }
      if (user._id !== this.props.sellerId) {
        // eslint-disable-next-line 
        this.setState({ reportDeleteIcon: <a onClick={this.report} className="btn options-item">Report <i style={{ color: '#c9a84c' }} className="fa fa-flag" aria-hidden="true" /></a> });
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.favorite === true) {
      this.setState({ isFavorited: true });
    }
    if (nextProps.share === true) {
      this.setState({ shareIcon: true });
    }
    if (nextProps.marketer) { // this works in detection of a marketer
      this.setState({ viewLink: `/share/${String(nextProps._id)}` });
    }
    if (nextProps.sold) {
      this.setState({ displaySold: 'block' });
    }
  }

  toProfile() {
    this.props.history.push('/');
  }
  iconState() {
    if (this.props.favorite === true) {
      this.setState({ isFavorited: true });
    }
    if (this.props.share === true) {
      this.setState({ shareIcon: true });
    }
  }

  // popup product control only shows if user is logged in
  delete() { // if item is sold and no tracking code sent, don't let it delete to do
    if (this.props.post_id) {
      Auth.fetch(`${constants.DOMAIN}/api/v1/posts/${String(this.props.post_id)}`, {
        mode: 'cors',
        method: 'DELETE',
      })
        .then(res => {
          alert('Post Deleted');
          this.props.feedReset();
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      Auth.fetch(`${constants.DOMAIN}/api/v1/posts/${String(this.props._id)}`, {
        mode: 'cors',
        method: 'DELETE',
      })
        .then(res => {
          alert('Post Deleted');
          this.props.feedReset();
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
  clipboard(data) {
    const body = document.getElementsByTagName('body')[0];
    const tempInput = document.createElement('INPUT');
    body.appendChild(tempInput);
    tempInput.setAttribute('value', data);
    tempInput.select();
    document.execCommand('copy');
    body.removeChild(tempInput);
  }
  copyLink() {
    if (Auth.getToken()) { // user is signed in
      const user = Auth.getProfile();
      if (this.props.post_id) { // If the post is a shared post
        if (user._id === this.props.marketer._id) { // Checking if user is marketer
          const url = `${constants.DOMAIN}/s/${String(this.props._id)}`;
          this.clipboard(url);
          alert('Copied');
        } else if (this.state.shareIcon === true) { // Checking if user has already shared post
          this.props.sortedProfile.forEach(post => {
            if (post.post_id === this.props.post_id) {
              const url = `${constants.DOMAIN}/s/${String(post._id)}`;
              this.clipboard(url);
              alert('Copied');
            }
          });
        } else {
          const url = `https://marketplace.primaltcg.com/product/${String(this.props._id)}`;
          this.clipboard(url);
          alert('Copied');
        }
      } else { // THIS IS NOT A SHARED POST
        if (this.state.shareIcon === true) { // Checking if user has already shared post
          this.props.sortedProfile.forEach(post => {
            if (post.post_id === this.props._id) {
              const url = `${constants.DOMAIN}/s/${String(post._id)}`;
              this.clipboard(url);
              alert('Copied');
            }
          });
        } else {
          const url = `https://marketplace.primaltcg.com/product/${String(this.props._id)}`;
          this.clipboard(url);
          alert('Copied');
        }
      }
    } else { // user is guest
      if (this.props.post_id) { // If the post is a shared post
        const url = `${constants.DOMAIN}/s/${String(this.props._id)}`;
        this.clipboard(url);
        alert('Copied');
      } else { // THIS IS NOT A SHARED POST
        const url = `https://marketplace.primaltcg.com/product/${String(this.props._id)}`;
        this.clipboard(url);
        alert('Copied');
      }
    }
  }
  report() {
    if (this.props.post_id) { // if this a shared post
      Auth.fetch(`${constants.DOMAIN}/api/v1/posts/${String(this.props.post_id)}/report`, {
        mode: 'cors',
        method: 'GET',
      })
        .then(res => {
          // console.log(res);
          alert(res.message);
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      Auth.fetch(`${constants.DOMAIN}/api/v1/posts/${String(this.props._id)}/report`, {
        mode: 'cors',
        method: 'GET',
      })
        .then(res => {
          alert(res.message);

          // console.log(res);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  favorite() {
    if (Auth.getToken()) {
      if (this.props.post_id) { // if this is a shared post
        Auth.fetch(`${constants.DOMAIN}/api/v1/posts/${String(this.props.post_id)}/favorite`, {
          mode: 'cors',
          method: 'POST',
        }).then(res => {
          if (this.state.isFavorited === true) {
            this.setState({
              isFavorited: false,
              favoriteCount: res.favoriteCount,
            });
          } else {
            this.setState({
              isFavorited: true,
              favoriteCount: res.favoriteCount,
            });
          }
        }).catch(err => {
          console.log(err);
        });
      } else {
        Auth.fetch(`${constants.DOMAIN}/api/v1/posts/${String(this.props._id)}/favorite`, {
          mode: 'cors',
          method: 'POST',
        }).then(res => {
          if (this.state.isFavorited === true) {
            this.setState({
              isFavorited: false,
              favoriteCount: res.favoriteCount,
            });
          } else {
            this.setState({
              isFavorited: true,
              favoriteCount: res.favoriteCount,
            });
          }
        }).catch(err => {
          console.log(err);
        });
      }
    } else {
      this.context.openAuthModal('login');
    }
  }

  share() {
    if (Auth.getToken()) {
      const user = Auth.getProfile();
      if (this.props.post_id) { // If the post is a shared post
        Auth.fetch(`${constants.DOMAIN}/api/v1/posts/${String(this.props.post_id)}/share`, {
          mode: 'cors',
          method: 'POST',
        }).then(res => {
          // console.log(res);
          if (this.state.shareIcon === true) {
            this.setState({
              shareIcon: false,
              shareCount: res.shareCount,
            }, () => {
              this.props.profile(user._id);
            });
          } else {
            // mixpanel.track('Share', { SharerID: user._id, ProductID: this.state.productId, Price: this.state.price, ShareCount: this.state.shareCount });
            this.setState({
              shareIcon: true,
              shareCount: res.post.shareCount,
            }, () => {
              this.props.profile(user._id);
            });
          }
        }).catch(err => {
          console.log(err);
        });
      } else { // if the post is not a shared post
        Auth.fetch(`${constants.DOMAIN}/api/v1/posts/${String(this.props._id)}/share`, {
          mode: 'cors',
          method: 'POST',
        }).then(res => {
          if (this.state.shareIcon === true) {
            this.setState({
              shareIcon: false,
              shareCount: res.shareCount,
            }, () => {
              this.props.profile(user._id);
            });
          } else {
            // mixpanel.track('Share', { SharerID: user._id, ProductID: this.state.productId, Price: this.state.price, ShareCount: this.state.shareCount });
            this.setState({
              shareIcon: true,
              shareCount: res.post.shareCount,
            }, () => {
              this.props.profile(user._id);
            });
          }
        }).catch(err => {
          console.log(err);
        });
      }
    } else {
      this.context.openAuthModal('login');
    }
  }

  // SOCIAL FUNCTIONS
  shareViaFacebook() { 
    const windowReference = window.open();
    if (Auth.getToken()) { // user is signed in
      const user = Auth.getProfile();
      if (this.props.post_id) { // If the post is a shared post
        if (user._id === this.props.marketer._id) { // Checking if user is marketer
          const url = `${constants.DOMAIN}/s/${String(this.props._id)}`;
          // const URL = `https://www.facebook.com/sharer.php?${url}`;

          const URL = `https://www.facebook.com/sharer/sharer.php?u=${url}.io&quote=Checkout%20this%20new%20product%20I%20found%20on%20primaltcg.com`;
          windowReference.location = URL;
        } else if (this.state.shareIcon === true) { // Checking if user has already shared post
          this.props.sortedProfile.forEach(post => {
            if (post.post_id === this.props.post_id) {
              const url = `${constants.DOMAIN}/s/${String(post._id)}`;
              // const URL = `https://www.facebook.com/sharer.php?${url}`;
              const URL = `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=Checkout%20this%20new%20product%20I%20found%20on%20primaltcg.com`;
              windowReference.location = URL;
            }
          });
        } else {
        // Share begins
          Auth.fetch(`${constants.DOMAIN}/api/v1/posts/${String(this.props.post_id)}/share`, {
            mode: 'cors',
            method: 'POST',
          }).then(res => {
          // Share is successful
            // mixpanel.track('Share', {
            // SharerID: user._id,
            // ProductID: this.props.post_id,
            // Price: this.props.price,
            // ShareCount: this.state.shareCount });
            // console.log('NewSHARE', res)
            this.setState({
              shareIcon: true,
              shareCount: res.post.shareCount,
            });
            this.props.profile(user._id);
            const url = `${constants.DOMAIN}/s/${String(res.share._id)}`;
            // const URL = `https://www.facebook.com/sharer.php?${url}`;
            const URL = `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=Checkout%20this%20new%20product%20I%20found%20on%20primaltcg.com`;
            windowReference.location = URL;
          })
            .catch(err => {
              console.log(err);
            });
        }
      } else { // THIS IS NOT A SHARED POST
        if (this.state.shareIcon === true) { // Checking if user has already shared post
          this.props.sortedProfile.forEach(post => {
            if (post.post_id === this.props._id) {
              const url = `${constants.DOMAIN}/s/${String(post._id)}`;
              // const URL = `https://www.facebook.com/sharer.php?${url}`;
              const URL = `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=Checkout%20this%20new%20product%20I%20found%20on%20primaltcg.com`;
              windowReference.location = URL;
            }
          });
        } else {
          Auth.fetch(`${constants.DOMAIN}/api/v1/posts/${String(this.props._id)}/share`, {
            mode: 'cors',
            method: 'POST',
          }).then(res => {
            // mixpanel.track('Share', {
            //   SharerID: user._id,
            //   ProductID: this.props._id,
            //   Price: this.props.price,
            //   ShareCount: this.state.shareCount });
            this.setState({
              shareIcon: true,
              shareCount: res.post.shareCount,
            });
            this.props.profile(user._id);
            // console.log(res);
            const url = `${constants.DOMAIN}/s/${String(res.share._id)}`;
            // const URL = `https://www.facebook.com/sharer.php?${url}`;
            const URL = `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=Checkout%20this%20new%20product%20I%20found%20on%20primaltcg.com`;
            windowReference.location = URL;
          })
            .catch(err => {
              console.log(err);
            });
        }
      }
    } else { // user is guest
      if (this.props.post_id) { // If the post is a shared post
        const url = `${constants.DOMAIN}/s/${String(this.props._id)}`;
        // const URL = `https://www.facebook.com/sharer.php?${url}`;
        const URL = `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=Checkout%20this%20new%20product%20I%20found%20on%20primaltcg.com`;
        windowReference.location = URL;
      } else { // THIS IS NOT A SHARED POST
        const url = `https://marketplace.primaltcg.com/product/${String(this.props._id)}`;
        // const URL = `https://www.facebook.com/sharer.php?${url}`;
        const URL = `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=Checkout%20this%20new%20product%20I%20found%20on%20primaltcg.com`;
        windowReference.location = URL;
      }
    }
  }

  shareViaPinterest() {
    const windowReference = window.open();
    if (Auth.getToken()) { // user is signed in
      const user = Auth.getProfile();
      if (this.props.post_id) { // THIS IS A SHARED POST
        if (user._id === this.props.marketer._id) { // Checking if user is marketer
          const url = `https%3A%2F%2Fprimaltcg.com%2Fshare%2F${String(this.props._id)}`;
          const imgurl = `https%3A%2F%2Fapi.primaltcg.com%2Fuploads%2F${String(this.props.image).substr(7)}`;
          const URL = `https://pinterest.com/pin/create/button/?url=${url}&media=${imgurl}&description=${String(this.props.title)}`;
          windowReference.location = URL;
        } else if (this.state.shareIcon === true) { // Checking if user has already shared post
          this.props.sortedProfile.forEach(post => {
            if (post.post_id === this.props.post_id) {
              const url = `https%3A%2F%2Fprimaltcg.com%2Fshare%2F${String(post._id)}`;
              const imgurl = `https%3A%2F%2Fapi.primaltcg.com%2Fuploads%2F${String(this.props.image).substr(7)}`;
              const URL = `https://pinterest.com/pin/create/button/?url=${url}&media=${imgurl}&description=${String(this.props.title)}`;
              windowReference.location = URL;
            }
          });
        } else {
        // Share begins
          Auth.fetch(`${constants.DOMAIN}/api/v1/posts/${String(this.props.post_id)}/share`, {
            mode: 'cors',
            method: 'POST',
          }).then(res => {
          // Share is successful
            // mixpanel.track('Share', {
            //   SharerID: user._id,
            //   ProductID: this.props.post_id,
            //   Price: this.props.price,
            //   ShareCount: this.state.shareCount });
            // console.log('NewSHARE', res)
            this.setState({
              shareIcon: true,
              shareCount: res.post.shareCount,
            });
            this.props.profile(user._id);
            const url = `https%3A%2F%2Fprimaltcg.com%2Fshare%2F${String(res.share._id)}`;
            const imgurl = `https%3A%2F%2Fapi.primaltcg.com%2Fuploads%2F${String(res.post.images[0]).substr(7)}`;
            const URL = `https://pinterest.com/pin/create/button/?url=${url}&media=${imgurl}&description=${String(res.post.title)}`;
            windowReference.location = URL;
          }).catch(err => {
            console.log(err);
          });
        }
      } else { // THIS IS NOT A SHARED POST
        if (this.state.shareIcon === true) { // Checking if user has already shared post
          this.props.sortedProfile.forEach(post => {
            if (post.post_id === this.props._id) {
              const url = `https%3A%2F%2Fprimaltcg.com%2Fshare%2F${String(post._id)}`;
              const imgurl = `https%3A%2F%2Fapi.primaltcg.com%2Fuploads%2F${String(this.props.image).substr(7)}`;
              const URL = `https://pinterest.com/pin/create/button/?url=${url}&media=${imgurl}&description=${String(this.props.title)}`;
              windowReference.location = URL;
            }
          });
        } else {
          Auth.fetch(`${constants.DOMAIN}/api/v1/posts/${String(this.props._id)}/share`, {
            mode: 'cors',
            method: 'POST',
          }).then(res => {
            // mixpanel.track('Share', {
            //   SharerID: user._id,
            //   ProductID: this.props._id,
            //   Price: this.props.price,
            //   ShareCount: this.state.shareCount,
            // });
            this.setState({
              shareIcon: true,
              shareCount: res.post.shareCount,
            });
            this.props.profile(user._id);
            // console.log(res);
            const url = `https%3A%2F%2Fprimaltcg.com%2Fshare%2F${String(res.share._id)}`;
            const imgurl = `https%3A%2F%2Fapi.primaltcg.com%2Fuploads%2F${String(res.post.images[0]).substr(7)}`;
            const URL = `https://pinterest.com/pin/create/button/?url=${url}&media=${imgurl}&description=${String(res.post.title)}`;
            windowReference.location = URL;
          })
            .catch(err => {
              console.log(err);
            });
        }
      }
    } else { // user is a guest
      if (this.props.post_id) { // THIS IS A SHARED POST
        const url = `https%3A%2F%2Fprimaltcg.com%2Fshare%2F${String(this.props._id)}`;
        const imgurl = `https%3A%2F%2Fapi.primaltcg.com%2Fuploads%2F${String(this.props.image).substr(7)}`;
        const URL = `https://pinterest.com/pin/create/button/?url=${url}&media=${imgurl}&description=${String(this.props.title)}`;
        windowReference.location = URL;
      } else { // THIS IS NOT A SHARED POST
        const url = `https%3A%2F%2Fprimaltcg.com%2Fproduct%2F${String(this.props._id)}`;
        const imgurl = `https%3A%2F%2Fapi.primaltcg.com%2Fuploads%2F${String(this.props.image).substr(7)}`;
        const URL = `https://pinterest.com/pin/create/button/?url=${url}&media=${imgurl}&description=${String(this.props.title)}`;
        windowReference.location = URL;
      }
    }
  }

  shareByTweet() {
    const windowReference = window.open();
    if (Auth.getToken()) { // user is signed in
      const user = Auth.getProfile();
      if (this.props.post_id) { // THIS IS A SHARED POST
        if (user._id === this.props.marketer._id) { // Checking if user is marketer
          const url = `${constants.DOMAIN}/s/${String(this.props._id)}`;
          const URL = `https://twitter.com/intent/tweet?text=Checkout%20this%20new%20product%20I%20found%20on%20%40PrimalTCG_io%20%20${url}`;
          windowReference.location = URL;
        } else if (this.state.shareIcon === true) { // Checking if user has already shared post
          this.props.sortedProfile.forEach(post => {
            if (post.post_id === this.props.post_id) {
              const url = `${constants.DOMAIN}/s/${String(post._id)}`;
              const URL = `https://twitter.com/intent/tweet?text=Checkout%20this%20new%20product%20I%20found%20on%20%40PrimalTCG_io%20%20${url}`;
              windowReference.location = URL;
            }
          });
        } else {
        // Share begins
          Auth.fetch(`${constants.DOMAIN}/api/v1/posts/${String(this.props.post_id)}/share`, {
            mode: 'cors',
            method: 'POST',
          }).then(res => {
          // Share is successful
            this.setState({
              shareIcon: true,
              shareCount: res.post.shareCount,
            }, () => {
              // mixpanel.track('Share', {
              //   SharerID: user._id,
              //   ProductID: this.props.post_id,
              //   Price: this.props.price,
              //   ShareCount: this.state.shareCount });
              this.props.profile(user._id);
              // console.log('NewSHARE', res)
              const url = `${constants.DOMAIN}/s/${String(res.share._id)}`;
              const URL = `https://twitter.com/intent/tweet?text=Checkout%20this%20new%20product%20I%20found%20on%20%40PrimalTCG_io%20%20${url}`;
              windowReference.location = URL;
            });
          }).catch(err => {
            console.log(err);
          });
        }
      } else { // THIS IS NOT A SHARED POST
        if (this.state.shareIcon === true) { // Checking if user has already shared post
          this.props.sortedProfile.forEach(post => {
            if (post.post_id === this.props._id) {
              const url = `${constants.DOMAIN}/s/${String(post._id)}`;
              const URL = `https://twitter.com/intent/tweet?text=Checkout%20this%20new%20product%20I%20found%20on%20%40PrimalTCG_io%20%20${url}`;
              windowReference.location = URL;
            }
          });
        } else {
          Auth.fetch(`${constants.DOMAIN}/api/v1/posts/${String(this.props._id)}/share`, {
            mode: 'cors',
            method: 'POST',
          }).then(res => {
            this.setState({
              shareIcon: true,
              shareCount: res.post.shareCount,
            }, () => {
              // mixpanel.track('Share', {
              //   SharerID: user._id,
              //   ProductID: this.props._id,
              //   Price: this.props.price,
              //   ShareCount: this.state.shareCount });
              this.props.profile(user._id);
              // console.log('SharedViaTwitter', res);
              const url = `${constants.DOMAIN}/s/${String(res.share._id)}`;
              const URL = `https://twitter.com/intent/tweet?text=Checkout%20this%20new%20product%20I%20found%20on%20%40PrimalTCG_io%20%20${url}`;
              windowReference.location = URL;
            });
          })
            .catch(err => {
              console.log(err);
            });
        }
      }
    } else { // user is a guest
      if (this.props.post_id) { // THIS IS A SHARED POST
        const url = `${constants.DOMAIN}/s/${String(this.props._id)}`;
        const URL = `https://twitter.com/intent/tweet?text=Checkout%20this%20new%20product%20I%20found%20on%20%40PrimalTCG_io%20%20${url}`;
        windowReference.location = URL;
      } else { // THIS IS NOT A SHARED POST
        const url = `https://marketplace.primaltcg.com/product/${String(this.props._id)}`;
        const URL = `https://twitter.com/intent/tweet?text=Checkout%20this%20new%20product%20I%20found%20on%20%40PrimalTCG_io%20%20${url}`;
        windowReference.location = URL;
      }
    }
  }

  render() {
    const api = `${constants.DOMAIN}/`;

    return (
      <div className="col-md-12 col-xs-12 post" style={{ paddingRight: '0px', paddingLeft: '0px' }}>
        <div className="col-xs-12 sharedByTop" style={{ padding: '0px' }}>
          {this.state.marketer}
        </div>
        <div className="col-md-12 col-xs-12 post-header">
          <div className="col-xs-4 col-md-2 avi col-lg-2" style={{ paddingRight: '0px' }}>
            {/* <a className="btn btn-primary" onClick={this.toProfile}> */}
            <Link to={`/shop/${String(this.props.userName)}`}>
              <img id="userPic" alt="userPic" src={api + this.props.picture} style={{ width: '70%' }} />
            </Link>
            {/* </a> */}
          </div>
          <div className="col-xs-5 col-sm-5 col-md-5 col-lg-6 userInfo" style={{ paddingRight: '0px', paddingLeft: '0px' }}>
            <Link to={`/shop/${String(this.props.userName)}`}>
              <strong><p id="name">{this.props.name}</p></strong>
              <StarRatingComponent
                name="productCompRating"
                editing={false}
                starCount={5}
                starColor="#ffd788"
                emptyStarColor="#939393"
                value={this.props.sellerRating}
              />
            </Link>
          </div>
          <div className="col-xs-3 col-sm-3 col-lg-4 ellipsis" style={{ textAlign: 'right' }}>
            <Popup
              trigger={                
                <a href="#options/" className="btn options">
                  <i className="fa fa-ellipsis-h fa-2x" />
                </a>}
              modal
              on="click"
              closeOnDocumentClick
              mouseLeaveDelay={300}
              mouseEnterDelay={0}
              contentStyle={{ padding: '0px', border: 'none' }}
              arrow={false}
            >
              <div className="options-menu">
                <div id="deleteOption" className="menu-item">
                  {this.state.reportDeleteIcon}
                </div>
                {this.state.editPost}
                <div id="tweetOption" className="menu-item">
                  <a href="#tweet/" className="btn options-item" onClick={this.shareByTweet}>Tweet <i style={{ color: '#1B95E0' }} className="fa fa-twitter" /></a>
                </div>
                <div id="facebookOption" className="menu-item">
                  <a href="#fb/" className="btn options-item" onClick={this.shareViaFacebook}>Share <i style={{ color: '#4267b2' }} className="fa fa-facebook" /></a>
                </div>
                <div id="pinOption" className="menu-item">
                  <a href="#pin/" className="btn options-item" onClick={this.shareViaPinterest}>Pin <i style={{ color: '#ad081b' }} className="fa fa-pinterest-p" /></a>
                </div>
                <div id="copyOption" className="menu-item">
                  <a href="#copy/" className="btn options-item" onClick={this.copyLink}>Copy Link <i style={{ color: '#ad081b' }} className="fa fa-clone" /></a>
                </div>
              </div>
            </Popup>

            {/* {this.state.reportDeleteIcon} */}
          </div>
        </div>
        <div className="col-md-12 col-xs-12 image" style={{ paddingRight: '0px', paddingLeft: '0px' }}>
          <Link id={`productCompContainer.${this.props._id}`} to={this.state.viewLink}>
            <img alt="loading" style={{ width: '100%' }} src={Loading} />
            {/* <div className="row post-title">
            <h1 id="title">{this.props.title}</h1>
          </div> */}
          </Link>
        </div>
        <div className="col-md-12 col-xs-12 post-action">
          <div className="col-xs-2 col-md-2 productIcon">
            {/* eslint-disable-next-line */}
            <span className="favoriteAndCount"><a className="btn btn-primary Icon" onClick={this.favorite} id="productfavoriteIcon">{
              this.state.isFavorited
                ? <i className="fa fa-heart fa-2x" />
                : <i className="fa fa-heart-o fa-2x" style={{ color: '#00000075' }} />
            }</a>
            {/* <div>&nbsp;</div> */}
            <Link className="btn Count" to={this.state.favoritesLink}>
              <p className="count" id="productfavoriteCount">{this.state.favoriteCount}</p>
            </Link>
            </span>
          </div>
          <div className="col-xs-2 col-md-2 productIcon">
            <span className="retweetAndCount">
              {/* eslint-disable-next-line */}
              <a className="btn btn-primary Icon" onClick={this.share}>
                {this.state.shareIcon
                  ? <i className="fa fa-retweet fa-2x" style={{ color: '#2155cf' }} />
                  : <i className="fa fa-retweet fa-2x" style={{ color: '#00000075' }} aria-hidden="true" />
                }
              </a>
              {/* <div>&nbsp;</div> */}
              <Link className="btn Count" to={this.state.sharesLink}>
                <p className="count" id="productShareCount">{this.state.shareCount}</p>
              </Link>
            </span>
          </div>
          <div className="col-xs-2 col-md-2 productIcon">
            <span className="commentProduct">
              <Link className="btn Icon" to={this.state.viewLink}>
                <i className="fa fa-comments-o fa-2x" style={{ color: '#00000075' }} />
              </Link>
              {/* <div className="spacer">&nbsp;</div> */}
              <Link className="btn Count" to={this.state.viewLink}>
                <p className="count" id="productCommentCount">{(this.props.comments || []).length}</p>
              </Link>
            </span>
          </div>
          <div className="col-xs-6 col-md-6 button">
            {this.state.productStatus}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Product);
